







































































import {
  defineComponent,
  ref,
  set,
  computed,
  PropType,
} from '@nuxtjs/composition-api'

type GroupItem = {
  name: string
  buttons: {
    add: string
    remove: string
  }
}

export default defineComponent({
  name: 'BlockMultiFields',
  components: {
    FormGenerator: () => import('@/components/FormGenerator.vue'),
    BlockMultiFieldsChild: () => import('@/components/BlockMultiFields.vue'),
  },
  props: {
    id: {
      type: String as PropType<string>,
      default: 'MultiFields',
    },
    value: {
      type: Array as PropType<any>,
      default: () => [],
    },
    label: {
      type: String as PropType<string>,
      default: '',
    },
    error: {
      type: [String, Boolean] as PropType<string | boolean>,
      default: '',
    },
    parentsModel: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    formModel: {
      type: Object as PropType<any>,
      default: () => {},
    },
    list: {
      type: Array as PropType<any>,
      default: () => {},
    },
    group: {
      type: Object as PropType<GroupItem>,
      default: () => {},
    },
    isSingleMode: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    isHasInitialItem: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
  },
  setup(props, { emit, refs }) {
    const fieldsList = ref<any>(props.value || [])
    // const listLimit = ref<number>(5)
    const listCounter = computed(() => fieldsList.value?.length)
    const showError = ref<boolean>(false)
    const validationCounter = ref<number>(0)

    const onUpdate = (fields, itemIndex) => {
      Object.keys(fields).forEach((fieldName) => {
        if (fieldsList.value.length === 0) {
          addItem()
        }
        set(fieldsList.value[itemIndex], fieldName, fields[fieldName])
      })
      emit('input', fieldsList.value)
    }

    // Если вернёт true то ошибки есть
    const checkErrors = async (showErrors = false) => {
      let isError = false
      validationCounter.value += 1
      if (Array.isArray(refs[props.id])) {
        // Перебираем потомков и инициируем валидацию
        for (const component of refs[props.id]) {
          const errorStatus = await component.checkErrors(showErrors)
          if (errorStatus) isError = true
          if (
            showErrors &&
            Object.prototype.hasOwnProperty.call(component, 'showError')
          ) {
            component.showError = showErrors || showError.value
          }
        }
      }
      return isError
    }

    const addItem = () => {
      const fields = {}
      props.list.forEach((item) => {
        fields[item.id] = item.initialModel || null
      })
      fieldsList.value.push({
        id: fieldsList.value.length + 1,
        groupName: props.id,
        ...fields,
      })
      emit('input', fieldsList.value)
    }

    const removeItem = (index) => {
      fieldsList.value.splice(index, 1)
    }

    // Если элементы не переданы, то добавляем первый
    if (
      (props.value === null || props.value.length < 1) &&
      props.isHasInitialItem
    ) {
      addItem()
    } else if (Array.isArray(props.value)) {
      fieldsList.value = props.value
    }

    return {
      onUpdate,
      addItem,
      removeItem,
      checkErrors,
      fieldsList,
      listCounter,
      validationCounter,
    }
  },
})
